import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckIcon, SparklesIcon, StarIcon, CrownIcon, WindIcon, CarIcon, AlertTriangleIcon, PhoneIcon, ClockIcon, WineIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const tabs = [{
  label: 'MK Hookah',
  icon: <WindIcon size={16} data-id="element-496" />
}, {
  label: 'Gold Package',
  icon: <SparklesIcon size={16} data-id="element-497" />
}, {
  label: 'Platinum Package',
  icon: <StarIcon size={16} data-id="element-498" />
}, {
  label: 'Neighborhood',
  icon: <AlertTriangleIcon size={16} data-id="element-499" />
}, {
  label: 'Parking',
  icon: <CarIcon size={16} data-id="element-500" />
}];
const hookahWeekday = [{
  time: '4:00 PM – 6:00 PM',
  price: '$15'
}, {
  time: '6:00 PM – 8:00 PM',
  price: '$25'
}, {
  time: '8:00 PM – 10:00 PM',
  price: '$35'
}];
const hookahWeekend = [{
  time: '2:00 PM – 4:00 PM',
  price: '$20'
}, {
  time: '4:00 PM – 6:00 PM',
  price: '$30'
}, {
  time: '6:00 PM – 8:00 PM',
  price: '$40'
}];
const flavours = [{
  brand: 'AL-FAKHER',
  items: ['Mint', 'Grape', 'Guava', 'Peach', 'Mango', 'Mojito', 'Cherry/Mint', 'Watermelon', 'Orange Mint', 'Blueberry Mint', 'Double Apple', 'Pineapple', 'MK Fresh', 'MK Vanilla', 'Gum Mint', 'Strawberry', 'Lemon Mint']
}, {
  brand: 'STARBUZZ',
  items: ['Blue Mist', 'Wildberry Mint', 'Sex on the Beach', 'Mighty Freeze']
}, {
  brand: 'ADALYA',
  items: ['Love 66', 'Lady Killer', 'Baku Nights', 'Mi Amor']
}];
const featuredBottles = [{
  name: 'Black Label',
  price: '$230',
  desc: 'A premium tier offering at MK Lounge on U.',
  image: 'https://cdn.magicpatterns.com/uploads/9iBGPPPDtc9rMCeCuJsaeK/WhatsApp-Image-2026-06-16-at-10.13.25-AM-4.jpg'
}, {
  name: 'Casamigos',
  price: '$300',
  desc: '',
  image: 'https://images.unsplash.com/photo-1569529465841-dfecdab7503b?w=120&h=160&fit=crop'
}, {
  name: 'Hennessy V.S',
  price: '$230',
  desc: "The world's most popular Cognac. Perfect for mixing or enjoying on its own.",
  image: 'https://images.unsplash.com/photo-1602858776890-f0a4b2683273?w=120&h=160&fit=crop'
}, {
  name: 'Don Julio 1942',
  price: '$500',
  desc: 'Handcrafted in small batches. Rich, smooth notes of vanilla, roasted agave, and light oak.',
  image: 'https://cdn.magicpatterns.com/uploads/2DziDyxptDKwZmZD2Ba3sW/WhatsApp-Image-2026-06-16-at-10.13.26-AM-5.jpg'
}, {
  name: 'Jameson Irish Whiskey',
  price: '$230',
  desc: 'Triple distilled, remarkably smooth, and unmistakably Jameson.',
  image: 'https://images.unsplash.com/photo-1527281400683-1aae777175f8?w=120&h=160&fit=crop'
}, {
  name: 'CÎROC Ultra-Premium',
  price: '$230',
  desc: 'Distilled from fine French grapes for an exquisitely smooth, fresh vodka experience.',
  image: 'https://images.unsplash.com/photo-1598018553943-29ace5bf1271?w=120&h=160&fit=crop'
}, {
  name: 'Rémy Martin VSOP',
  price: '$270',
  desc: 'Embodies the perfect harmony of powerful and elegant aromas.',
  image: 'https://images.unsplash.com/photo-1619451334792-150fd785ee74?w=120&h=160&fit=crop'
}];
export function BottleServicePage({
  onBack,
  onReserve
}: {
  onBack: () => void;
  onReserve: () => void;
}) {
  const [activeSlide, setActiveSlide] = useState(0);
  return <div className="min-h-screen w-full bg-[#050505] pt-24 pb-20 px-4 sm:px-6" data-id="element-501">
      <div className="max-w-5xl mx-auto" data-id="element-502">
        {/* Back */}
        <motion.button initial={{
        opacity: 0,
        x: -10
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.4
      }} onClick={onBack} className="flex items-center gap-2 font-montserrat text-[12px] tracking-widest text-white/40 hover:text-[#C9A84C] transition-colors duration-300 mb-10" data-id="element-503">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" data-id="element-504">
            <path d="M10 3L5 8l5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-505" />
          </svg>
          BACK TO HOME
        </motion.button>

        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-506">
          <span className="font-inter text-[13px] tracking-[0.4em] text-[#C9A84C]/60 uppercase" data-id="element-507">
            Our Services
          </span>
          <h1 className="font-montserrat font-black text-4xl sm:text-5xl tracking-widest text-white mt-2" data-id="element-508">
            PACKAGES & TABLE SERVICE
          </h1>
          <div className="w-14 h-px bg-[#C9A84C]/50 mx-auto mt-4 mb-5" data-id="element-509" />
          <p className="font-inter font-light text-[16px] text-white/55 max-w-2xl mx-auto leading-relaxed" data-id="element-510">
            We're in the business of making sure our customers get the highest
            quality of nightlife experience.
          </p>
        </motion.div>

        {/* Tab Navigation */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="flex gap-2 overflow-x-auto pb-4 mb-8 hide-scrollbar -mx-2 px-2" data-id="element-511">
          {tabs.map((tab, i) => <button key={tab.label} onClick={() => setActiveSlide(i)} className={`flex items-center gap-2 flex-shrink-0 font-montserrat font-700 text-[11px] tracking-widest px-5 py-3 rounded-xl transition-all duration-300 ${activeSlide === i ? 'bg-[#C9A84C] text-[#050505]' : 'border border-[#2A2622] text-white/50 hover:text-[#C9A84C] hover:border-[#C9A84C]/40'}`} data-id="element-512">
              {tab.icon}
              {tab.label.toUpperCase()}
            </button>)}
        </motion.div>

        {/* Slide Content */}
        <AnimatePresence mode="wait" data-id="element-513">
          <motion.div key={activeSlide} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -10
        }} transition={{
          duration: 0.35
        }} className="mb-20" data-id="element-514">
            {/* ===== SLIDE 0: MK HOOKAH ===== */}
            {activeSlide === 0 && <div className="space-y-10" data-id="element-515">
                <div className="rounded-3xl p-8 sm:p-10" style={{
              background: '#0d0b09',
              border: '1px solid #2A2622'
            }} data-id="element-516">
                  <p className="font-inter text-white/60 text-lg leading-relaxed mb-8" data-id="element-517">
                    Our upscale lounge is home to the highest quality of hookah
                    in Washington DC.
                  </p>

                  {/* Pricing */}
                  <h3 className="font-montserrat font-black text-xl tracking-widest text-white mb-6" data-id="element-518">
                    HOOKAH PRICING
                  </h3>

                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8" data-id="element-519">
                    {/* Weekday */}
                    <div className="rounded-2xl p-5" style={{
                  background: 'rgba(201,168,76,0.05)',
                  border: '1px solid rgba(201,168,76,0.15)'
                }} data-id="element-520">
                      <p className="font-montserrat font-black text-[11px] tracking-widest text-[#C9A84C] mb-1" data-id="element-521">
                        MON – FRI
                      </p>
                      <p className="font-inter text-[10px] text-white/40 mb-4" data-id="element-522">
                        Happy Hour
                      </p>
                      {hookahWeekday.map(slot => <div key={slot.time} className="flex items-center justify-between py-2 border-b border-white/5 last:border-0" data-id="element-523">
                          <span className="font-inter text-sm text-white/60" data-id="element-524">
                            {slot.time}
                          </span>
                          <span className="font-montserrat font-black text-sm text-[#C9A84C]" data-id="element-525">
                            {slot.price}
                          </span>
                        </div>)}
                    </div>

                    {/* Weekend */}
                    <div className="rounded-2xl p-5" style={{
                  background: 'rgba(201,168,76,0.05)',
                  border: '1px solid rgba(201,168,76,0.15)'
                }} data-id="element-526">
                      <p className="font-montserrat font-black text-[11px] tracking-widest text-[#C9A84C] mb-1" data-id="element-527">
                        SAT & SUN
                      </p>
                      <p className="font-inter text-[10px] text-white/40 mb-4" data-id="element-528">
                        Weekend
                      </p>
                      {hookahWeekend.map(slot => <div key={slot.time} className="flex items-center justify-between py-2 border-b border-white/5 last:border-0" data-id="element-529">
                          <span className="font-inter text-sm text-white/60" data-id="element-530">
                            {slot.time}
                          </span>
                          <span className="font-montserrat font-black text-sm text-[#C9A84C]" data-id="element-531">
                            {slot.price}
                          </span>
                        </div>)}
                    </div>

                    {/* After 10 */}
                    <div className="rounded-2xl p-5 flex flex-col items-center justify-center text-center" style={{
                  background: 'rgba(201,168,76,0.08)',
                  border: '1px solid rgba(201,168,76,0.25)'
                }} data-id="element-532">
                      <p className="font-montserrat font-black text-[11px] tracking-widest text-[#C9A84C] mb-1" data-id="element-533">
                        ALL DAYS
                      </p>
                      <p className="font-inter text-[10px] text-white/40 mb-3" data-id="element-534">
                        After 10:00 PM
                      </p>
                      <span className="font-montserrat font-black text-3xl text-[#C9A84C]" data-id="element-535">
                        $50
                      </span>
                      <span className="font-inter text-xs text-white/40 mt-1" data-id="element-536">
                        All Hookah
                      </span>
                    </div>
                  </div>

                  {/* Flavour Menu */}
                  <h3 className="font-montserrat font-black text-xl tracking-widest text-white mb-6" data-id="element-537">
                    FLAVOUR MENU
                  </h3>

                  <div className="space-y-5 mb-8" data-id="element-538">
                    {flavours.map(brand => <div key={brand.brand} data-id="element-539">
                        <p className="font-montserrat font-black text-[12px] tracking-widest text-[#C9A84C] mb-3" data-id="element-540">
                          {brand.brand}
                        </p>
                        <div className="flex flex-wrap gap-2" data-id="element-541">
                          {brand.items.map(f => <span key={f} className="font-inter text-xs text-white/70 px-3 py-1.5 rounded-full" style={{
                      background: 'rgba(201,168,76,0.08)',
                      border: '1px solid rgba(201,168,76,0.15)'
                    }} data-id="element-542">
                              {f}
                            </span>)}
                        </div>
                      </div>)}
                  </div>

                  {/* Footer notes */}
                  <div className="border-t border-[#2A2622] pt-5 space-y-2" data-id="element-543">
                    <p className="font-inter text-xs text-white/50" data-id="element-544">
                      4 People per Hookah &nbsp;|&nbsp; 4 Cool Change
                      &nbsp;|&nbsp; Additional Coal: $2.00
                    </p>
                    <p className="font-inter text-xs text-white/35 italic" data-id="element-545">
                      Please note: Charcoals & Mouthpieces are limited.
                    </p>
                  </div>
                </div>
              </div>}

            {/* ===== SLIDE 1: GOLD PACKAGE ===== */}
            {activeSlide === 1 && <div className="rounded-3xl overflow-hidden" style={{
            background: '#0d0b09',
            border: '1px solid #2A2622'
          }} data-id="element-546">
                {/* Package header */}
                <div className="p-8 sm:p-10 text-center border-b border-[#2A2622]" style={{
              background: 'rgba(201,168,76,0.04)'
            }} data-id="element-547">
                  <div className="w-16 h-16 rounded-2xl mx-auto flex items-center justify-center mb-4" style={{
                background: 'rgba(201,168,76,0.12)',
                border: '1px solid rgba(201,168,76,0.25)'
              }} data-id="element-548">
                    <SparklesIcon size={28} className="text-[#C9A84C]" data-id="element-549" />
                  </div>
                  <p className="font-montserrat text-[11px] tracking-widest text-[#C9A84C]/60 mb-1" data-id="element-550">
                    TIER 1
                  </p>
                  <h2 className="font-montserrat font-black text-3xl tracking-widest text-white mb-3" data-id="element-551">
                    GOLD PACKAGE
                  </h2>
                  <span className="font-montserrat font-black text-5xl text-[#C9A84C]" data-id="element-552">
                    $700
                  </span>
                </div>

                <div className="p-8 sm:p-10" data-id="element-553">
                  {/* Includes */}
                  <h4 className="font-montserrat font-black text-[12px] tracking-widest text-white/40 mb-4" data-id="element-554">
                    PACKAGE INCLUDES
                  </h4>
                  <ul className="space-y-3 mb-8" data-id="element-555">
                    {['Two Bottle Top Shelf Liquor', 'One House Champagne', 'One Hookah', 'Tax & Gratuity included in the price'].map(item => <li key={item} className="flex items-center gap-3" data-id="element-556">
                        <div className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0" style={{
                    background: 'rgba(201,168,76,0.15)'
                  }} data-id="element-557">
                          <CheckIcon size={12} className="text-[#C9A84C]" data-id="element-558" />
                        </div>
                        <span className="font-inter text-[15px] text-white/70" data-id="element-559">
                          {item}
                        </span>
                      </li>)}
                  </ul>

                  {/* Reservation Details */}
                  <h4 className="font-montserrat font-black text-[12px] tracking-widest text-white/40 mb-4" data-id="element-560">
                    RESERVATION DETAILS
                  </h4>
                  <div className="grid grid-cols-2 gap-3 mb-8" data-id="element-561">
                    {[{
                  label: 'DEPOSIT',
                  value: '$350.00',
                  note: 'Non-refundable'
                }, {
                  label: 'TAX & GRATUITY',
                  value: 'Included',
                  note: 'In price'
                }, {
                  label: 'FREE ENTRANCE',
                  value: '6 People',
                  note: 'Free entry'
                }, {
                  label: 'AGE LIMIT',
                  value: '21+',
                  note: 'And up'
                }].map(detail => <div key={detail.label} className="rounded-xl p-4" style={{
                  background: 'rgba(255,255,255,0.03)',
                  border: '1px solid #2A2622'
                }} data-id="element-562">
                        <p className="font-montserrat text-[9px] tracking-widest text-white/35 mb-1" data-id="element-563">
                          {detail.label}
                        </p>
                        <p className="font-montserrat font-black text-lg text-white" data-id="element-564">
                          {detail.value}
                        </p>
                        <p className="font-inter text-[10px] text-white/30" data-id="element-565">
                          {detail.note}
                        </p>
                      </div>)}
                  </div>

                  {/* Table Time */}
                  <h4 className="font-montserrat font-black text-[12px] tracking-widest text-white/40 mb-4" data-id="element-566">
                    TABLE TIME
                  </h4>
                  <div className="flex gap-3 mb-8" data-id="element-567">
                    {['9:00 PM – 12:00 AM', '12:00 AM – 3:00 AM'].map(t => <div key={t} className="flex items-center gap-2 rounded-xl px-4 py-3" style={{
                  background: 'rgba(201,168,76,0.06)',
                  border: '1px solid rgba(201,168,76,0.15)'
                }} data-id="element-568">
                        <ClockIcon size={14} className="text-[#C9A84C]" data-id="element-569" />
                        <span className="font-inter text-sm text-white/70" data-id="element-570">
                          {t}
                        </span>
                      </div>)}
                  </div>

                  {/* Reserve CTA */}
                  <div className="rounded-2xl p-6 text-center" style={{
                background: 'rgba(201,168,76,0.06)',
                border: '1px solid rgba(201,168,76,0.2)'
              }} data-id="element-571">
                    <p className="font-montserrat font-black text-sm tracking-widest text-white mb-3" data-id="element-572">
                      TO RESERVE
                    </p>
                    <div className="flex flex-col sm:flex-row gap-3 justify-center" data-id="element-573">
                      <a href="sms:2029095158" className="inline-flex items-center justify-center gap-2 font-montserrat font-black text-[12px] tracking-widest bg-[#C9A84C] text-[#050505] px-6 py-3.5 rounded-xl hover:bg-[#E8C97A] transition-colors" data-id="element-574">
                        <PhoneIcon size={14} data-id="element-575" />
                        (202) 909-5158
                      </a>
                      <a href="sms:2027540850" className="inline-flex items-center justify-center gap-2 font-montserrat font-black text-[12px] tracking-widest border border-[#C9A84C]/50 text-[#C9A84C] px-6 py-3.5 rounded-xl hover:bg-[#C9A84C]/10 transition-colors" data-id="element-576">
                        <PhoneIcon size={14} data-id="element-577" />
                        (202) 754-0850
                      </a>
                    </div>
                  </div>
                </div>
              </div>}

            {/* ===== SLIDE 2: PLATINUM PACKAGE ===== */}
            {activeSlide === 2 && <div className="rounded-3xl overflow-hidden" style={{
            background: '#0d0b09',
            border: '1px solid rgba(201,168,76,0.3)'
          }} data-id="element-578">
                <div className="p-8 sm:p-10 text-center border-b border-[#2A2622]" style={{
              background: 'rgba(201,168,76,0.06)'
            }} data-id="element-579">
                  <div className="inline-block px-4 py-1 rounded-full font-montserrat font-black text-[10px] tracking-widest text-[#050505] bg-[#C9A84C] mb-4" data-id="element-580">
                    MOST POPULAR
                  </div>
                  <div className="w-16 h-16 rounded-2xl mx-auto flex items-center justify-center mb-4" style={{
                background: 'rgba(201,168,76,0.2)',
                border: '1px solid rgba(201,168,76,0.35)'
              }} data-id="element-581">
                    <StarIcon size={28} className="text-[#C9A84C]" data-id="element-582" />
                  </div>
                  <p className="font-montserrat text-[11px] tracking-widest text-[#C9A84C]/60 mb-1" data-id="element-583">
                    TIER 2
                  </p>
                  <h2 className="font-montserrat font-black text-3xl tracking-widest text-white mb-3" data-id="element-584">
                    PLATINUM PACKAGE
                  </h2>
                </div>

                <div className="p-8 sm:p-10" data-id="element-585">
                  <h4 className="font-montserrat font-black text-[12px] tracking-widest text-white/40 mb-4" data-id="element-586">
                    PACKAGE INCLUDES
                  </h4>
                  <ul className="space-y-3 mb-8" data-id="element-587">
                    {['Two Bottle Top Shelf Liquor', 'One Belair Rosé Bottle', 'One Hookah & One Hookah Head', 'Tax & Gratuity included in the price'].map(item => <li key={item} className="flex items-center gap-3" data-id="element-588">
                        <div className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0" style={{
                    background: 'rgba(201,168,76,0.2)'
                  }} data-id="element-589">
                          <CheckIcon size={12} className="text-[#C9A84C]" data-id="element-590" />
                        </div>
                        <span className="font-inter text-[15px] text-white/70" data-id="element-591">
                          {item}
                        </span>
                      </li>)}
                  </ul>

                  <h4 className="font-montserrat font-black text-[12px] tracking-widest text-white/40 mb-4" data-id="element-592">
                    RESERVATION DETAILS
                  </h4>
                  <div className="grid grid-cols-2 gap-3 mb-8" data-id="element-593">
                    {[{
                  label: 'DEPOSIT',
                  value: '$400.00',
                  note: 'Non-refundable'
                }, {
                  label: 'TAX & GRATUITY',
                  value: 'Included',
                  note: 'In price'
                }, {
                  label: 'FREE ENTRANCE',
                  value: '8 Guests',
                  note: 'Free entry'
                }, {
                  label: 'AGE LIMIT',
                  value: '21+',
                  note: 'And up'
                }].map(detail => <div key={detail.label} className="rounded-xl p-4" style={{
                  background: 'rgba(255,255,255,0.03)',
                  border: '1px solid #2A2622'
                }} data-id="element-594">
                        <p className="font-montserrat text-[9px] tracking-widest text-white/35 mb-1" data-id="element-595">
                          {detail.label}
                        </p>
                        <p className="font-montserrat font-black text-lg text-white" data-id="element-596">
                          {detail.value}
                        </p>
                        <p className="font-inter text-[10px] text-white/30" data-id="element-597">
                          {detail.note}
                        </p>
                      </div>)}
                  </div>

                  <h4 className="font-montserrat font-black text-[12px] tracking-widest text-white/40 mb-4" data-id="element-598">
                    TABLE TIME
                  </h4>
                  <div className="flex gap-3 mb-8" data-id="element-599">
                    {['9:00 PM – 12:00 AM', '12:00 AM – 3:00 AM'].map(t => <div key={t} className="flex items-center gap-2 rounded-xl px-4 py-3" style={{
                  background: 'rgba(201,168,76,0.06)',
                  border: '1px solid rgba(201,168,76,0.15)'
                }} data-id="element-600">
                        <ClockIcon size={14} className="text-[#C9A84C]" data-id="element-601" />
                        <span className="font-inter text-sm text-white/70" data-id="element-602">
                          {t}
                        </span>
                      </div>)}
                  </div>

                  <div className="rounded-2xl p-6 text-center" style={{
                background: 'rgba(201,168,76,0.06)',
                border: '1px solid rgba(201,168,76,0.2)'
              }} data-id="element-603">
                    <p className="font-montserrat font-black text-sm tracking-widest text-white mb-3" data-id="element-604">
                      TO RESERVE
                    </p>
                    <div className="flex flex-col sm:flex-row gap-3 justify-center" data-id="element-605">
                      <a href="sms:2029095158" className="inline-flex items-center justify-center gap-2 font-montserrat font-black text-[12px] tracking-widest bg-[#C9A84C] text-[#050505] px-6 py-3.5 rounded-xl hover:bg-[#E8C97A] transition-colors" data-id="element-606">
                        <PhoneIcon size={14} data-id="element-607" />
                        (202) 909-5158
                      </a>
                      <a href="sms:2027540850" className="inline-flex items-center justify-center gap-2 font-montserrat font-black text-[12px] tracking-widest border border-[#C9A84C]/50 text-[#C9A84C] px-6 py-3.5 rounded-xl hover:bg-[#C9A84C]/10 transition-colors" data-id="element-608">
                        <PhoneIcon size={14} data-id="element-609" />
                        (202) 754-0850
                      </a>
                    </div>
                  </div>
                </div>
              </div>}

            {/* ===== SLIDE 3: NEIGHBORHOOD NOTICE ===== */}
            {activeSlide === 3 && <div className="rounded-3xl p-8 sm:p-12 text-center" style={{
            background: '#0d0b09',
            border: '1px solid #2A2622'
          }} data-id="element-610">
                <div className="w-16 h-16 rounded-full mx-auto flex items-center justify-center mb-6" style={{
              background: 'rgba(201,168,76,0.1)',
              border: '1px solid rgba(201,168,76,0.2)'
            }} data-id="element-611">
                  <AlertTriangleIcon size={28} className="text-[#C9A84C]" data-id="element-612" />
                </div>
                <h3 className="font-montserrat font-black text-2xl tracking-widest text-white mb-6" data-id="element-613">
                  NEIGHBORHOOD NOTICE
                </h3>
                <p className="font-inter text-lg text-white/60 leading-relaxed max-w-xl mx-auto mb-6" data-id="element-614">
                  Please respect our neighbors. You are requested to keep noise
                  to a minimum when leaving these premises. Thank you.
                </p>
                <p className="font-montserrat font-700 text-sm tracking-widest text-[#C9A84C]" data-id="element-615">
                  — MK LOUNGE ON U
                </p>
              </div>}

            {/* ===== SLIDE 4: PARKING NOTICE ===== */}
            {activeSlide === 4 && <div className="rounded-3xl p-8 sm:p-12 text-center" style={{
            background: '#0d0b09',
            border: '1px solid #2A2622'
          }} data-id="element-616">
                <div className="w-16 h-16 rounded-full mx-auto flex items-center justify-center mb-6" style={{
              background: 'rgba(201,168,76,0.1)',
              border: '1px solid rgba(201,168,76,0.2)'
            }} data-id="element-617">
                  <CarIcon size={28} className="text-[#C9A84C]" data-id="element-618" />
                </div>
                <h3 className="font-montserrat font-black text-2xl tracking-widest text-white mb-6" data-id="element-619">
                  PARKING NOTICE
                </h3>
                <p className="font-inter text-lg text-white/60 leading-relaxed max-w-xl mx-auto mb-4" data-id="element-620">
                  Due to road closures and limited parking available on 9th and
                  U Street, we suggest our customers use ride share apps. Metro
                  stations are available close by the lounge.
                </p>
                <p className="font-inter text-base text-white/40" data-id="element-621">
                  Thank you for understanding.
                </p>
              </div>}
          </motion.div>
        </AnimatePresence>

        {/* ===== FEATURED BOTTLES ===== */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} data-id="element-622">
          <div className="text-center mb-8" data-id="element-623">
            <h2 className="font-montserrat font-black text-2xl sm:text-3xl tracking-widest text-white" data-id="element-624">
              TODAY'S FEATURED BOTTLES
            </h2>
            <p className="font-inter text-xs text-white/35 mt-2" data-id="element-625">
              *Prices do not include tax (10%) and service charge (20%).
            </p>
          </div>

          <div className="space-y-3 mb-16" data-id="element-626">
            {featuredBottles.map((bottle, i) => <motion.div key={bottle.name} initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.4,
            delay: 0.35 + i * 0.06
          }} className="flex items-center gap-4 sm:gap-6 rounded-2xl p-5" style={{
            background: i % 2 === 0 ? '#0d0b09' : 'rgba(201,168,76,0.03)',
            border: '1px solid #2A2622'
          }} data-id="element-627">
                <div className="w-14 h-14 rounded-xl overflow-hidden flex-shrink-0 border border-[#2A2622]" data-id="element-628">
                  <img src={bottle.image} alt={bottle.name} className="w-full h-full object-cover" data-id="element-629" />
                </div>
                <div className="flex-1 min-w-0" data-id="element-630">
                  <h4 className="font-montserrat font-black text-sm tracking-widest text-white truncate" data-id="element-631">
                    {bottle.name.toUpperCase()}
                  </h4>
                  {bottle.desc && <p className="font-inter text-xs text-white/40 mt-0.5 line-clamp-1 sm:line-clamp-2" data-id="element-632">
                      {bottle.desc}
                    </p>}
                </div>
                <span className="font-montserrat font-black text-lg text-[#C9A84C] flex-shrink-0" data-id="element-633">
                  {bottle.price}
                </span>
              </motion.div>)}
          </div>
        </motion.div>

        {/* ===== BOTTOM RESERVATION CTA ===== */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.5
      }} className="rounded-3xl p-8 sm:p-10 text-center" style={{
        background: 'rgba(201,168,76,0.05)',
        border: '1px solid rgba(201,168,76,0.2)'
      }} data-id="element-634">
          <p className="font-montserrat font-black text-xl tracking-widest text-white mb-2" data-id="element-635">
            READY TO RESERVE?
          </p>
          <p className="font-inter text-[15px] text-white/50 mb-6 max-w-lg mx-auto leading-relaxed" data-id="element-636">
            Text us to book your table and package. Our team will confirm your
            reservation within minutes.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center" data-id="element-637">
            <a href="sms:2029095158" className="inline-flex items-center justify-center gap-2 font-montserrat font-black text-[13px] tracking-widest bg-[#C9A84C] text-[#050505] px-8 py-4 rounded-xl hover:bg-[#E8C97A] transition-colors duration-300" style={{
            boxShadow: '0 4px 20px rgba(201,168,76,0.25)'
          }} data-id="element-638">
              <PhoneIcon size={16} data-id="element-639" />
              TEXT (202) 909-5158
            </a>
            <a href="sms:2027540850" className="inline-flex items-center justify-center gap-2 font-montserrat font-black text-[13px] tracking-widest border border-[#C9A84C]/50 text-[#C9A84C] px-8 py-4 rounded-xl hover:bg-[#C9A84C]/10 hover:border-[#C9A84C] transition-all duration-300" data-id="element-640">
              <PhoneIcon size={16} data-id="element-641" />
              TEXT (202) 754-0850
            </a>
          </div>
        </motion.div>
      </div>
    </div>;
}